module.exports = __webpack_public_path__ + "static/sc_anim_glitch-2-c1421f0fabc01a98d097c1a054ff8415.gif";